//import Libraries
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input, InputGroup, InputGroupText, Button, InputGroupAddon} from 'reactstrap';

import {storageRef} from '../../../firebase';

//import Components
import QuantitySelector from '../Props/QuantitySelector';
import AddToCartButton from '../Props/AddToCartButton';
import DetailButton from '../Props/DetailButton';

//import Styles

import './DetailProduct.css';

const marginStyle = {
    margin : '10px 10px',
    display : 'inline'
}

class DetailProduct extends Component {

    constructor (props) {
        super(props);
        this.state = {
            quantity : 1,
            typeIndex : 0,
            url : ''
        }
    }

    handleQuantityChange = (e) => {
        if(e.target.value > this.props.product.stock) {
            return;
        }
        if(e.target.value >= 0) {
            this.setState({
                [e.target.name] : e.target.value
            })
        }
    }

    handleTypeIndexChange = (e) => {
        this.setState({
            typeIndex : Number(e.target.value)
        })
    } 

    incQuantity = ()=>{
        this.setState((prevState) => ({
            quantity : prevState.quantity + 1
        }))
    }
    decQuantity = ()=>{
        this.setState((prevState) => ({
            quantity : prevState.quantity - 1
        }))
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.product.id !== this.props.product.id) {
            this.loadImageFromStorage();
        }
    }

    componentDidMount() {
        this.loadImageFromStorage();
    }

    loadImageFromStorage = () => {
        storageRef.child(`product_images/${this.props.product.id}.jpg`).getDownloadURL()
            .then((url) => {
                this.setState({
                    url
                })
            });
    }

    render() {
        const {name, description, id, types, prices } = this.props.product;

        const renderImg =  this.state.url === '' ? 
                            <div className="product-image">Loading</div>  : 
                            <div className="product-image">
                                <img className="product-image" src={this.state.url} />
                            </div>

        const renderTypes = types && types.map((type, index) => {
            return (
                <option key={index} value={index}>{type}</option>
            );
        })

        const won = prices ? prices[this.state.typeIndex] : 'undefined';

        return (
            <div className="product-card">
                {
                    renderImg
                }
                <div className="product-content">
                    <div className="product-title"> 
                        <h3><span>{name[this.props.lang]}</span></h3>
                    </div>
                    <div className="product-detail">
                        <p>
                            {description[this.props.lang]}
                        </p>
                    </div>
                    {/* <ul className="product-stock">
                        <li>재고</li>
                        <li>{stock}</li>
                    </ul> */}
                    <InputGroup className="product-type">
                        <InputGroupAddon addonType="prepend">종류</InputGroupAddon>
                        <Input type="select" onChange={this.handleTypeIndexChange}>
                            {renderTypes}
                        </Input>
                        {/* <React.Fragment>
                            <InputGroupText>가격</InputGroupText>
                            <InputGroupAddon addonType="append" className="product-price">{`${won}원`}</InputGroupAddon>
                        </React.Fragment> */}
                    </InputGroup>
                    <InputGroup className="product-command">
                        <InputGroupAddon addonType="prepend">수량</InputGroupAddon>
                        <Input 
                            onChange={this.handleQuantityChange}
                            value={this.state.quantity}
                            name="quantity"/>
                        <InputGroupAddon addonType="append">
                            <InputGroupText color="secondary" onClick={this.decQuantity}>-</InputGroupText>
                            <InputGroupText color="secondary" onClick={this.incQuantity}>+</InputGroupText>
                            <Button 
                                color="danger" 
                                id={id} 
                                onClick={() => {
                                    this.props.onAddToCart({
                                        id,
                                        typeIndex : this.state.typeIndex, 
                                        quantity : this.state.quantity
                                    })
                                }}
                                outline 
                            >
                                    장바구니 추가
                            </Button>
                        </InputGroupAddon>
                    </InputGroup>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return{
        lang: state.universal.language,
        login : state.user.login
    }
}

export default connect(mapStateToProps, null)(DetailProduct);


// WEBPACK FOOTER //
// ./src/pages/Store/DetailProduct/DetailProduct.js